import { createClient } from '@sanity/client';

// Debug: Check if token exists
console.log('Sanity Token exists:', !!process.env.REACT_APP_SANITY_TOKEN);
console.log('Token value (first 5 chars):', process.env.REACT_APP_SANITY_TOKEN ? process.env.REACT_APP_SANITY_TOKEN.substring(0, 5) : 'none');

const client = createClient({
  projectId: '6pwobkdm',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-03-20',
  token: process.env.REACT_APP_SANITY_TOKEN
});

// Test the client connection immediately
(async () => {
  try {
    console.log('Testing Sanity connection...');
    const result = await client.fetch('*[_type == "post"][0...10]');
    console.log('Connection successful, sample data:', result);
  } catch (error) {
    console.error('Sanity connection test failed:', error);
    console.error('Error details:', {
      message: error.message,
      statusCode: error.statusCode,
      responseBody: error.responseBody,
    });
  }
})();

// Debug function to check all documents
const getAllDocuments = async () => {
  try {
    const result = await client.fetch('*[]');
    console.log('All documents in dataset:', result);
    return result;
  } catch (error) {
    console.error('Error fetching all documents:', error);
    console.error('Error details:', {
      message: error.message,
      statusCode: error.statusCode,
      responseBody: error.responseBody,
    });
    throw error;
  }
};

export const getPosts = async () => {
  try {
    console.log('Fetching posts from Sanity...');
    const query = `*[_type == "post"] | order(publishedAt desc) {
      _id,
      title,
      "slug": slug.current,
      publishedAt,
      excerpt,
      mainImage {
        asset-> {
          _id,
          url
        }
      }
    }`;
    console.log('Query:', query);
    const posts = await client.fetch(query);
    console.log('Fetched posts:', posts);
    return posts;
  } catch (error) {
    console.error('Error in getPosts:', error);
    console.error('Error details:', {
      message: error.message,
      statusCode: error.statusCode,
      responseBody: error.responseBody,
    });
    throw error;
  }
};

export const getPost = async (slug) => {
  if (!slug) {
    console.error('No slug provided to getPost');
    throw new Error('No slug provided');
  }
  
  try {
    console.log('Fetching post with slug:', slug);
    const query = `*[_type == "post" && slug.current == $slug][0] {
      _id,
      title,
      "slug": slug.current,
      publishedAt,
      excerpt,
      body[] {
        ...,
        _type == "image" => {
          ...,
          asset->
        }
      },
      mainImage {
        asset-> {
          _id,
          url
        }
      }
    }`;
    console.log('Query:', query);
    console.log('Params:', { slug });
    const post = await client.fetch(query, { slug });
    console.log('Fetched post data:', post);
    
    if (!post) {
      console.error('No post found with slug:', slug);
      throw new Error('Post not found');
    }
    
    return post;
  } catch (error) {
    console.error('Error in getPost:', error);
    console.error('Error details:', {
      message: error.message,
      statusCode: error.statusCode,
      responseBody: error.responseBody,
      slug: slug
    });
    throw error;
  }
};